import type { AssignmentPresentation as AssignmentPresentationType } from 'bundles/compound-assessments/components/api/AssignmentPresentation';
import type { AsyncMachineTask } from 'bundles/compound-assessments/components/api/types/OnDemandAssignmentPresentationsQuery';

export type GitStatuses = {
  isGitInitializationFailed: boolean;
  isGitInitializationInProgress: boolean;
  gitRelatedAsyncTask?: AsyncMachineTask;
};

export const getGitStatuses = (assignment: AssignmentPresentationType): GitStatuses => {
  const gitRelatedAsyncTasks = assignment.phases
    .map((phase) => {
      if (phase?.typeName === 'singleFormPhase') {
        return phase?.definition?.relatedAsyncTasks?.find(
          (relatedAsyncTask) => relatedAsyncTask.baseTaskId === 'GIT_INITIALIZATION'
        );
      }
      return undefined;
    })
    .filter(Boolean);
  const gitRelatedAsyncTask = gitRelatedAsyncTasks[0];

  const isGitInitializationFailed = typeof gitRelatedAsyncTask?.errorMessage === 'string';
  const isGitInitializationInProgress =
    typeof gitRelatedAsyncTask?.startedAt === 'number' && !isGitInitializationFailed; // Failed state will still have startedAt

  return {
    isGitInitializationFailed,
    isGitInitializationInProgress,
    gitRelatedAsyncTask,
  };
};
